<script>
// import Vue from 'vue'
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import axios from 'axios'
import tablaSucursales from "./tablaSucursales.vue"
import { todoMethods, todoComputed } from "@/state/helpers";
import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);


// Vue.use(VueAxios, axios)

export default {
  page: {
    title: "Sucursales",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    tablaSucursales,
  },


  data() {
    return {
      filters: {
				total: { value: '', keys: ['total'] }
			},
      post:[],

// ************************************** Link
      title: "Sucursales",
      items: [
        {
          text: "Negocios",
          href: "/Negocios",
        },
        {
          text: "Sucursales",
          active: true,
        },
      ],
    
      tableSucursales: [],
      search: '',
      info: null,
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      todocurrentPage: 1,
      current: 1,
      perPage: 10,
      statData: 1,
      todoperPage: 10,
      pageOptions: [10, 25, 50, 100],
      todoOptions: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortBy: "age",
      sortDesc: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#FFFFFF",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,

    };
  },

  computed: {

    ...todoComputed,
    /**
     * Total no. of records
     */
    rows() {
      return this.tableSucursales.length;
    },

    /**
     * Todo list of records
     */
    todoList() {
      return this.todos.length;
    },
  },
  
	mounted() {
		
		this.getTable();

    // Set the initial number of items
    this.totalRows = this.response.data.data.length;

    this.todoTotalRows = this.todos.length;

    axios
    .get("collection.json") 
    .then(function(response){
      console.log(response.data.item[1])
    });

    setTimeout(() => {
      this.showModal = true;
    }, 1500);
  },

  methods: {

		getTable(){
			const id_negocio = this.$route.params.id_negocio;
			axios.get(`https://bdd7w9ysj6.execute-api.us-west-1.amazonaws.com/app/sucursales/${id_negocio}`)
			.then((res) => {
				const {response="",data=[]} = res.data;
				if (response === true) {
					console.log(data);
					this.tableSucursales = data;
				} else {
					this.tableSucursales = [];
				}
			})
			.catch(err => {
				console.log(err);
				this.tableSucursales = [];
			});
		},

		toNewRegister(){
			this.$router.push({
				name:'nuevaSucursal',
				params:{
					id_negocio: this.$route.params.id_negocio
				}
			})
		},

    ...todoMethods,

    getColor (estado) {
        if (estado == "Activo") return 'red'
        else return 'green'
      },

    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value;
    },
    
  },


};
</script>
<template>
  <Layout>
  <PageHeader :title="title" :items="items" />
  <v-row>
     <v-col md="12">
      <v-card>
        <div class="card-body">
          <v-row>
            <v-col md="6">
              <h4 class="card-title mb-4">Lista de Tarjetas</h4>
            </v-col>
            <v-col md="6 text-md-end">
              <!-- <router-link to=""> -->
                <v-btn depressed color="primary" @click="toNewRegister()" >
                  Nuevo registro 
                </v-btn>
              <!-- </router-link> -->
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  Ver 
                  <v-divider
                    class="mx-1"
                    inset
                    horizontal
                  ></v-divider>
                  <b-form-select
                    class="form-select form-select-sm"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                  <v-divider
                    class="mx-1"
                    inset
                    horizontal
                  ></v-divider>
                    registros
                </label>
              </div>
            </v-col>
            <!-- Search -->
            <v-col md="6 text-md-end" >
							<div class="search-wrapper">
									<label> Buscar :</label>
									<v-divider
										class="mx-2"
										inset
										vertical
									></v-divider>
								<input type="text" v-model="search" placeholder="Buscar ..." />
							</div>
							<div class="wrapper">
								<div class="card">
								</div>
							</div>
            </v-col>
          </v-row>
          <!-- End search -->
          <v-row>
            <v-col md="12">
							<tablaSucursales
								:filters="filters"
								:tableSucursales="tableSucursales"
								:updating="fetchingStats"
								responsive="sm"
								:per-page="perPage"
								:current-page="current"
								:sort-by.sync="sortBy"
								:sort-desc.sync="sortD"
								:filter="filter"
								:filter-included-fields="filterOn"
								@filtered="onFiltered"
							/>
            </v-col>
					</v-row>
					<v-row>
					<v-col md="12">
							<b-pagination
								align="right"
								v-model="currentPage"
								:total-rows="rows"
								:per-page="perPage"
								first-text="Primera"
								prev-text="Anterior"
								next-text="Siguiente"
								last-text="Última"
							></b-pagination>
						</v-col>
            <v-col md="12">
							Mostrando {{currentPage}} de {{totalRows}}  registros
						</v-col>
          </v-row>
        </div>
      </v-card>
    </v-col>
   <!-- end col -->
  </v-row>
 <!-- end row -->
</Layout>
</template>
